import type { ISystemParam } from '../interfaces/system-params';
import type { NotificationSystemSettings } from './notification-configuration-api.service';

export const NOTIFICATION_EVENT_AGE_PARAM_ID =
  'notifications:maximumEventAgeSeconds';

export type NotificationSystemSettingsResult =
  | { available: true; value: NotificationSystemSettings }
  | { available: false; value: null };

export function notificationEventAgeParam(
  result: NotificationSystemSettingsResult,
  canManage: boolean,
): ISystemParam {
  const settings = result.value;
  const seconds = settings?.maximumEventAgeSeconds ?? null;

  return {
    id: NOTIFICATION_EVENT_AGE_PARAM_ID,
    name: 'Максимальный возраст входящего события',
    value: result.available && seconds !== null ? String(seconds) : '',
    listValue: result.available
      ? seconds === null
        ? 'Без ограничения'
        : `${seconds} с`
      : 'Недоступно',
    description: result.available
      ? 'Срок в секундах, после которого событие не запускает рассылку. Пустое значение отключает ограничение.'
      : 'Сервис уведомлений недоступен',
    minValue: 1,
    maxValue: null,
    inputMask: '[0-9]',
    regexpMask: '',
    isProtected: !result.available || !canManage,
    revision: settings?.revision,
  };
}

export function parseMaximumEventAge(value: string): number | null {
  const normalized = value.trim();
  if (!normalized) return null;

  const seconds = Number(normalized);
  if (!Number.isSafeInteger(seconds) || seconds <= 0)
    throw new Error(
      'Максимальный возраст события должен быть целым числом секунд больше нуля или пустым значением',
    );
  return seconds;
}
